import React, { useState, useCallback, useEffect, useRef } from 'react';
import moment from 'moment';
import { useIntl } from 'umi';
import { useSetState } from 'ahooks';
import Filter from '@/pages/intelligence/components/Filter';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import useGenreComponent from '@/pages/intelligence/hooks/useGenreComponent';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import _ from 'lodash-es';

export default function StreamingKOLFilter(props: any) {
  const {
    filterConfirm,
    filterReset,
    timeFilterValues,
    headQuatersOptionsData,
    regionsOptions,
    rangeTimeComponentDefault,
    platfromValueList,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const [stat, setState] = useSetState({
    languageDisable: true,
    countySelectDisable: true,
  });
  const allList = useRef({
    language: undefined,
    countries: undefined,
  });
  const onFetchSuccess = (data) => {
    if (data.every((item) => item === 'twitch')) {
      setState({
        languageDisable: false,
        countySelectDisable: true,
      });
    } else if (data.every((item) => item === 'ytg')) {
      setState({
        languageDisable: true,
        countySelectDisable: false,
      });
    } else {
      setState({
        languageDisable: true,
        countySelectDisable: true,
      });
    }
  };
  const defaultValue = {
    [filterKeyMap.RANGE_TIME]: {
      type: 'date',
      value: ['', ''],
    },
    [filterKeyMap.GENRETOR]: {
      source: 'iegg',
      mainGenres: [],
      subGenres: [],
    },
    [filterKeyMap.KOL_PLATFORM]: { value: platfromValueList },
    [filterKeyMap.KOL_LANGUAGE]: {
      value: [],
    },
    [filterKeyMap.KOL_COUNTRIES]: {
      value: [],
    },
  };
  // 继承逻辑在这写
  // formValue改成用ref，可提供给父组件回填时间， 或添加继承逻辑提供formValue给父组件
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend, resetDetailFilterExtend } =
    useFilterExtend({});

  const extendDefaultValue = !isOperateDetail
    ? defaultValue
    : {
        [filterKeyMap.RANGE_TIME]: {
          type:
            detailFilterExtend[filterKeyMap.RANGE_TIME]?.filterType ??
            defaultValue[filterKeyMap.RANGE_TIME]?.type,
          value:
            detailFilterExtend[filterKeyMap.RANGE_TIME]?.filterValue ??
            defaultValue[filterKeyMap.RANGE_TIME]?.value,
        },
        [filterKeyMap.GENRETOR]: {
          source:
            detailFilterExtend[filterKeyMap.GENRETOR]?.genretor?.source ??
            defaultValue[filterKeyMap.GENRETOR]?.source,
          mainGenres:
            detailFilterExtend[filterKeyMap.GENRETOR]?.genretor?.mainGenres ??
            defaultValue[filterKeyMap.GENRETOR]?.mainGenres,
          subGenres:
            detailFilterExtend[filterKeyMap.GENRETOR]?.genretor?.subGenres ??
            defaultValue[filterKeyMap.GENRETOR]?.subGenres,
        },
        [filterKeyMap.KOL_PLATFORM]: {
          value:
            detailFilterExtend[filterKeyMap.KOL_PLATFORM]?.value ??
            defaultValue[filterKeyMap.KOL_PLATFORM]?.value,
        },
        [filterKeyMap.KOL_LANGUAGE]: {
          value:
            detailFilterExtend[filterKeyMap.KOL_LANGUAGE]?.value ??
            defaultValue[filterKeyMap.KOL_LANGUAGE]?.value,
        },
        [filterKeyMap.KOL_COUNTRIES]: {
          value:
            detailFilterExtend[filterKeyMap.KOL_COUNTRIES]?.value ??
            defaultValue[filterKeyMap.KOL_COUNTRIES]?.value,
        },
      };

  const formValueRef = useRef(extendDefaultValue);

  const {
    genreRef,
    genreSource,
    mainGenres,
    subGenres,
    handleGenresChange,
    handleReset: handleGenresReset,
  } = useGenreComponent(props);
  const companyRef = useRef();
  const defaultInputList = {
    RANGE_TIME: {
      type: filterKeyMap.RANGE_TIME,
      key: filterKeyMap.RANGE_TIME,
      calendarType: 'date',
      componentDefault: rangeTimeComponentDefault,
    },
    GENRETOR: {
      key: filterKeyMap.GENRETOR,
      default: defaultValue[filterKeyMap.GENRETOR],
      genreData: {
        genreRef,
        genreSource,
        mainGenres,
        subGenres,
        handleGenresChange,
        handleGenresReset,
      },
    },
    KOL_PLATFORM: {
      key: filterKeyMap.KOL_PLATFORM,
      default: defaultValue[filterKeyMap.KOL_PLATFORM],
      onFetchSuccess,
    },
    KOL_LANGUAGE: {
      key: filterKeyMap.KOL_LANGUAGE,
      type: filterKeyMap.KOL_LANGUAGE,
      title: 'common_language',
      isShowTypeSelect: false,
      disabled: stat.languageDisable,
      options: [],
      disabledMessages: 'dbi_Primary_disabled_messages1',
    },
    KOL_COUNTRIES: {
      key: filterKeyMap.KOL_COUNTRIES,
      type: filterKeyMap.KOL_COUNTRIES,
      title: 'common_Country',
      isShowTypeSelect: false,
      isShowIcon: true,
      disabled: stat.countySelectDisable,
      options: [],
      disabledMessages: 'dbi_Primary_disabled_messages2',
    },
  };
  const list = [];
  list.push(defaultInputList.RANGE_TIME);
  list.push(defaultInputList.GENRETOR);
  list.push(defaultInputList.KOL_PLATFORM);
  list.push(defaultInputList.KOL_LANGUAGE);
  list.push(defaultInputList.KOL_COUNTRIES);
  const [inputList, setInputList] = useState(list);
  const updateHeadQuatersOptions = useCallback(
    (inputList: any[], inputListTmp: any[], type: string, list: any[] | boolean) => {
      const headQuatersIndex = inputList?.findIndex((item) => item?.key === type);
      const headQuaterSelectorTmp = inputListTmp?.[headQuatersIndex];
      if (
        headQuatersIndex !== -1 &&
        headQuaterSelectorTmp &&
        Reflect.has(headQuaterSelectorTmp, 'options')
      ) {
        if (typeof list === 'boolean') {
          headQuaterSelectorTmp.disabled = list ?? [];
        } else {
          headQuaterSelectorTmp.options = list ?? [];
        }
      }
    },
    [],
  );
  const updateHeadQuatersDefaultValue = useCallback(() => {
    const allValues = headQuatersOptionsData?.map((item: { value: any }) => item?.value);
    const allValues2 = regionsOptions?.map((item: { value: any }) => item?.value);
    formValueRef.current[filterKeyMap.KOL_LANGUAGE].value = stat.languageDisable
      ? allList.current.language
      : allValues;
    // !stat.languageDisable ? allList.current.language : allValues;
    formValueRef.current[filterKeyMap.KOL_COUNTRIES].value = stat.countySelectDisable
      ? allList.current.countries
      : allValues2;
    // stat.countySelectDisable ? allList.current.countries : allValues2;
    if (_.isEmpty(allList.current.language)) {
      allList.current.language = allValues;
    }
    if (_.isEmpty(allList.current.countries)) {
      allList.current.countries = allValues2;
    }
  }, [headQuatersOptionsData, regionsOptions, stat.countySelectDisable, stat.languageDisable]);

  useEffect(() => {
    const inputListTmp = [...inputList];
    setInputList(inputListTmp);
  }, [formatMessage]);

  const updateTimeComponentDefault = (inputList: any[]) => {
    const inputListTmp = inputList?.map((item) => {
      // 更新最早有数据时间
      if (rangeTimeComponentDefault) {
        if (item?.key === filterKeyMap.RANGE_TIME) {
          return {
            ...item,
            componentDefault: rangeTimeComponentDefault,
          };
        }
      }
      return item;
    });
    return inputListTmp;
  };

  useEffect(() => {
    let inputListTmp = [...inputList];
    // 更新Headquaters||Countrues筛选器选项数据
    updateHeadQuatersOptions(
      inputList,
      inputListTmp,
      filterKeyMap.KOL_LANGUAGE,
      headQuatersOptionsData,
    );
    updateHeadQuatersOptions(inputList, inputListTmp, filterKeyMap.KOL_COUNTRIES, regionsOptions);
    // 更新Headquaters筛选器value 为 默认全选
    updateHeadQuatersDefaultValue();

    inputListTmp = updateTimeComponentDefault(inputListTmp);

    setInputList(inputListTmp);
  }, [headQuatersOptionsData, regionsOptions, rangeTimeComponentDefault]);

  useEffect(() => {
    let inputListTmp = [...inputList];
    updateHeadQuatersOptions(
      inputList,
      inputListTmp,
      filterKeyMap.KOL_LANGUAGE,
      stat.languageDisable,
    );
    updateHeadQuatersOptions(
      inputList,
      inputListTmp,
      filterKeyMap.KOL_COUNTRIES,
      stat.countySelectDisable,
    );

    inputListTmp = updateTimeComponentDefault(inputListTmp);

    setInputList(inputListTmp);
  }, [stat, updateHeadQuatersOptions, rangeTimeComponentDefault]);

  useEffect(() => {
    // 更新Headquaters筛选器value 为 默认全选
    updateHeadQuatersDefaultValue();
  }, [stat, updateHeadQuatersDefaultValue]);

  /** 时间筛选器值由父组件更新 */
  useEffect(() => {
    if (Array.isArray(timeFilterValues?.value) && timeFilterValues?.value.length === 2) {
      formValueRef.current = {
        ...formValueRef.current,
        [filterKeyMap.RANGE_TIME]: {
          type: feachTimeTypeToFilterTimeType(timeFilterValues.type), // TODO
          value: [moment(timeFilterValues.value[0]), moment(timeFilterValues.value[1])],
        },
      };
    }
  }, [JSON.stringify(timeFilterValues.type), JSON.stringify(timeFilterValues.value)]);

  const onConfirm = useCallback(
    (value /** 筛选器数据 */, apiValue /** 筛选器转换后的数据 */) => {
      formValueRef.current = value;
      const filterForm = {
        period: apiValue[filterKeyMap.RANGE_TIME]?.granularity,
        start_date: apiValue[filterKeyMap.RANGE_TIME]?.start_date,
        end_date: apiValue[filterKeyMap.RANGE_TIME]?.end_date,
        genre: apiValue[filterKeyMap.GENRETOR]?.genre,
        // isDiffIeggLength: apiValue[filterKeyMap.GENRETOR]?.genretor?.mainGenres,
        sub_genre: apiValue[filterKeyMap.GENRETOR]?.sub_genre,
        genre_source: apiValue[filterKeyMap.GENRETOR]?.genre_source,
        iegg_genre_req: apiValue[filterKeyMap.GENRETOR]?.iegg_genre_req,
        platfrom: apiValue[filterKeyMap.KOL_PLATFORM]?.value,
        language: apiValue[filterKeyMap.KOL_LANGUAGE]?.value,
        market: apiValue[filterKeyMap.KOL_COUNTRIES]?.value,
      };
      if (!stat.languageDisable) {
        filterForm.language =
          apiValue[filterKeyMap.KOL_LANGUAGE]?.value.length === allList.current.language.length
            ? []
            : apiValue[filterKeyMap.KOL_LANGUAGE]?.value;
      } else {
        filterForm.language = [];
      }
      if (!stat.countySelectDisable) {
        filterForm.market =
          apiValue[filterKeyMap.KOL_COUNTRIES]?.value.length === allList.current.countries.length
            ? []
            : apiValue[filterKeyMap.KOL_COUNTRIES]?.value;
      } else {
        filterForm.market = [];
      }
      filterConfirm(filterForm);
      setDetailFilterExtend(apiValue);
    },
    [filterConfirm, stat.countySelectDisable, stat.languageDisable],
  );

  const onReset = (value) => {
    formValueRef.current = {
      ...defaultValue,
      [filterKeyMap.RANGE_TIME]: {
        type: 'date',
        value: rangeTimeComponentDefault?.date,
      },
    };
    genreRef.current?.reset();
    companyRef?.current?.reset();
    resetDetailFilterExtend();
    if (filterReset instanceof Function) {
      filterReset();
      setState({
        languageDisable: true,
        countySelectDisable: true,
      });
    }
  };

  return (
    <Filter
      value={formValueRef.current}
      inputList={inputList}
      onConfirm={onConfirm}
      onReset={onReset}
      defaultValue={{
        ...defaultValue,
        [filterKeyMap.RANGE_TIME]: {
          type: 'date',
          value: rangeTimeComponentDefault?.date,
        },
      }}
    />
  );
}
